import React from 'react';

import ActivitySetupStepCoproValidation from '../../components/Analyzing/StepCoproValidation';


function ActivitySetupStepCoproValidationView() {
  return (
    <ActivitySetupStepCoproValidation />
  );
}

export default ActivitySetupStepCoproValidationView;
